module.exports = {"id":"181560","name":"Mapou Yanga-M'Biwa","rating":"74","photo":"./data/images/photos/0/181560.png","club":{"name":"OL","logo":"./data/images/clubs/OL.png"},"positions":["DC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MapouYanga-M'Biwa0.json
// module id = 2691
// module chunks = 0